import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser, inTable } = {}) => {
  const inTableColor = isKiteUser
    ? theme.palette.primary1
    : theme.palette.pressed;

  return {
    button: {
      color: inTable ? inTableColor : 'white',
      fontWeight: isKiteUser ? '400' : '600',
      textDecoration: 'none',
      fontStyle: 'normal',
      fontSize: '14px',
      height: 44,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      '&, &:hover': {
        backgroundColor: inTable
          ? '#F4F4F4 !important'
          : theme.palette.primary1,
        borderRadius: '20px',
      },
    },
  };
});
